export const flagLinks = [
  {
    value: 'fr',
    href: 'https://www.manomano.fr/',
    name: 'ManoMano FR',
    dataQa: 'contactFlagFRCta',
  },
  {
    value: 'it',
    href: 'https://www.manomano.it/',
    name: 'ManoMano IT',
    dataQa: 'contactFlagITCta',
  },
  {
    value: 'gb',
    href: 'https://www.manomano.co.uk/',
    name: 'ManoMano UK',
    dataQa: 'contactFlagUKCta',
  },
  {
    value: 'de',
    href: 'https://www.manomano.de/',
    name: 'ManoMano DE',
    dataQa: 'contactFlagDECta',
  },
  {
    value: 'es',
    href: 'https://www.manomano.es/',
    name: 'ManoMano ES',
    dataQa: 'contactFlagESCta',
  },
];
